import React, { useState } from 'react';
import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import './index.scss';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const CustomInputField = styled(OutlinedInput)(({ theme }) => ({
  opacity: 1,
  backgroundColor: theme.palette.grey.A100,
  border: 0,
  borderRadius: '6px',
  fontSize: '18px',
  fontWeight: 500,
  outline: 'none',
  marginTop: '5px',
  width: '100%',
  color: theme.palette.text.secondary,
  '& .MuiOutlinedInput-input': {
    padding: '11px 14px',
    borderRadius: '6px',
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.text.secondary,
  },
  '& .MuiInputAdornment-root .MuiIconButton-root': {
    color: theme.palette.text.secondary,
  },
  '& textarea.MuiOutlinedInput-input': {
    padding: '0 !important',
  },
  '&.Mui-focused': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  '&.Mui-focused .MuiOutlinedInput-input': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey.A400,
    borderRadius: '6px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1px',
  },
  '& .MuiInputAdornment-root .select-wrap': {
    marginRight: '-14px',
  },
  '& .MuiInputAdornment-root .select-wrap .MuiOutlinedInput-root': {
    margin: 0,
  },
  '& .MuiInputAdornment-root .select-wrap .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
    borderWidth: '0 0 0 1px',
    borderRadius: 0,
  },
  '& .MuiInputAdornment-root .select-wrap .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey.A400,
  },
  '& .MuiInputAdornment-root .select-wrap .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey.A400,
  },
}));

const PrimaryTextField = React.forwardRef(
  ({
    onChange, onBlur, onFocus, value, name, label, placeholder, isPassword = false,
    multiline = false, sx, endAdornment, type = 'text', startAdornment, rows = 1,
    disabled = false, inputProps = undefined, onKeyDown = undefined, maxRows = 1,
  }: any, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <>
        {label && <Typography variant="body1">{label}</Typography>}
        {isPassword ? (
          <CustomInputField
            onChange={onChange ?? undefined}
            endAdornment={(
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )}
            type={showPassword ? 'text' : 'password'}
            onBlur={onBlur ?? undefined}
            onFocus={onFocus ?? undefined}
            value={value ?? undefined}
            name={name ?? undefined}
            inputRef={ref ?? undefined}
            placeholder={placeholder ?? undefined}
            sx={sx}
            disabled={disabled}
            fullWidth
            inputProps={inputProps}
          />
        ) : (
          <CustomInputField
            onChange={onChange ?? undefined}
            onBlur={onBlur ?? undefined}
            value={value ?? undefined}
            name={name ?? undefined}
            inputRef={ref ?? undefined}
            placeholder={placeholder ?? undefined}
            fullWidth
            multiline={multiline}
            sx={sx}
            endAdornment={endAdornment ?? undefined}
            startAdornment={startAdornment ?? undefined}
            type={type}
            rows={rows ?? false}
            maxRows={maxRows ?? false}
            disabled={disabled}
            inputProps={inputProps}
            onKeyDown={onKeyDown}
          />
        )}
      </>
    );
  },
);

export default PrimaryTextField;
